module.exports = "<button class={{vm.buttonClass}} ng-switch on=vm.active ng-disabled=\"vm.active || vm.disabled\" ng-if=!vm.href> <span ng-switch-when=false type={{vm.type}}><i class={{vm.stateNormalIcon}}></i> <span ng-class=vm.spanClass>{{vm.stateNormalText}}</span></span> <span ng-switch-when=true type=button><i class={{vm.stateActiveIcon}} ng-disabled=true></i> <span ng-class=vm.spanClass>{{vm.stateActiveText}}</span></span> </button> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/button-spinner/button-spinner.html
 ** module id = 43
 ** module chunks = 0
 **/